// @flow

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

import Stepper from '../../../../../components/Stepper';
import EllipsisLoader from '../../../../../components/EllipsisLoader';
import eventsApi from '../../../../../network/api/eventsApi';
import type { EventTile, EventTileWithOpeningStore } from '../../../../../types/eventType';
import SelectComponent from '../../../../common/SelectComponent';
import { reconciliationFlag } from '../../../../../const';
import type { History } from '../../../../../types/commonTypes';
import { notifyApolloError } from '../../../../../network/notification';

type Props = {
  // Redux
  history: History,
  location: Location,
  notifyApolloError: (e: EventHandler) => void,

  pcId: number,
  isMallBase?: boolean,
  updateClickedOpeningEvent: (EventTileWithOpeningStore) => void,
  updateIsLoading: (boolean) => boolean,
}

type State = {
  steps: EventTile[],
  distinctEventTypes: string[],
  selectedEventType: string,
}

class StepperContainer extends React.PureComponent<Props, State> {
  state = {
    steps: null,
    distinctEventTypes: [],
    selectedEventType: null,
  };

  componentDidMount() {
    this.fetchAllEventsOfCenter();
  }

  componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
    if (prevProps.pcId !== this.props.pcId) {
      this.fetchAllEventsOfCenter();
    }
  }

  fetchAllEventsOfCenter() {
    this.props.updateIsLoading(true);
    eventsApi.fetchAllForCenter(this.props.pcId, true)
      .then(resp => resp.json())
      .then((events) => {
        const distinctTypes = [...new Set(events.flatMap(event => event.tags))];
        if (!distinctTypes.includes(reconciliationFlag.OPENING)
            && events.filter(ev => ev.openingStore).length > 0) {
          distinctTypes.push(reconciliationFlag.OPENING);
        }
        this.setState({ steps: events, distinctEventTypes: distinctTypes });
        if (!!events && events.length > 0) {
          this.changeRoute(events[0]);
        }
      }).catch(this.props.notifyApolloError)
      .finally(() => this.props.updateIsLoading(false));
  }

  changeRoute(step: EventTile) {
    const { location, history } = this.props;
    if (location) {
      this.selectStep(step.id);
      this.props.updateClickedOpeningEvent(step.openingStore ? step : null);
      let params = step.openingStore ? `opening=${step.id}` : `event=${step.id}`;
      params += this.props.isMallBase ? `&mall=${this.props.pcId}` : '';
      history.push(`${location.pathname}?${params}`);
    }
  }

  selectStep(id: number) {
    this.setState({
      steps:
        this.state.steps && this.state.steps.map((step) => {
          step.selected = step && step.id === id;
          return step;
        }),
    });
  }

  isOpeningEvent(step: EventTile) {
    return this.state.selectedEventType === reconciliationFlag.OPENING
        && (step.tags.includes(this.state.selectedEventType) || step.openingStore);
  }

  isOfSelectedEventType = (step: EventTile) => this.isOpeningEvent(step)
    || step.tags.includes(this.state.selectedEventType);


  render() {
    const { steps, distinctEventTypes, selectedEventType } = this.state;
    return (
      <>
        {
          !!steps && !steps.isEmpty && (
            <div className="stepper-container-title">
              <div className="stepper-container-title-text">
                <h2>{I18n.t('header.EVENTS')}</h2>
                <span>{I18n.t('header.lastFiveYears')}</span>
              </div>
              { this.state.distinctEventTypes.length > 0 &&
                <SelectComponent
                  className="stepper-container-selector"
                  handleChange={type => this.setState({ selectedEventType: type })}
                  current={this.state.selectedEventType}
                  options={
                    [{ label: I18n.t('option.ALL'), value: null }]
                      .concat(distinctEventTypes.map(type => ({ label: type, value: type })))
                  }
                />
              }
            </div>
          )
        }
        {
          !!steps
          && !steps.isEmpty
            ? (
              <div className="stepper-steps-container">
                {steps
                  .filter(openingEvent => (selectedEventType !== null ? this.isOfSelectedEventType(openingEvent) : true))
                  .map(step =>
                  (<Stepper
                    key={step.id}
                    title={step.title}
                    subtitle={null}
                    info={step.info}
                    id={step.id}
                    onClick={() => this.changeRoute(step)}
                    selected={step.selected}
                    isOpeningStore={step.openingStore}
                  />))}
              </div>
            ) : (
              <EllipsisLoader />
            )
        }
      </>
    );
  }
}

export default withRouter(connect(
  null,
  {
    notifyApolloError,
  },
)(StepperContainer));
